import React, { useState, useEffect, useContext } from "react";
import Header from "../../context/Header";
import { AuthContext } from "../../context/Auth.js";
import app from "../../context/base.js";
import { Card, Button, Form, Table } from "react-bootstrap";
import { useHistory } from "react-router-dom";

const PhysicianMyRequests = ({ component: RouteComponent, ...rest }) => {
  const [tests, setTests] = useState([]);

   const history = useHistory();
   
   var { currentUser } = useContext(AuthContext);

  useEffect(() => {
    var myTests = [];

    //currentUser.uid
    app
      .firestore()
       .collection("tests")
       .where("physicianAccepted", "==", currentUser.uid)
      .get()
      .then((snapshot) => {
        var i = 1;
        snapshot.forEach((doc) => {
          var data = doc.data();
          data.id = doc.id;
          data.num = i++;
          myTests.push(data);
        });
        setTests(myTests);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [currentUser.uid]);

  function tableRows(test) {
    return (
      <td>
        {test.labSelected?.name !== undefined
          ? test.labSelected.name
          : "Not Selected"}
        {test.labSelected?.address === undefined ? <></> : <br />}
        {test.labSelected?.address !== undefined ? test.labSelected?.address : ""}
        {test.labSelected?.turnaroundTime === undefined ? <></> : <br />} 
        {test.labSelected?.turnaroundTime !== undefined
          ? "Turnaround: " + test.labSelected?.turnaroundTime + " day(s)"
          : ""}
      </td>
    );
  }

  function openRequest(test) {
      history.push({
        pathname: "/p-physician-request-details",
        state: { detail: test },
      });
  }

  

  function handleGoNextPage() {}

  return (
    <article>
      <Header />

      <Card>
        <Card.Body>
          <Card.Title>My History</Card.Title>
          <Form onSubmit={handleGoNextPage}>
            <Table striped bordered hover size="sm">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Collection Site or Lab</th>
                  
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {tests.map((test) => {
                  return (
                    <tr key={test.num}>
                      <td>{test.num}</td>
                      <td>{test.passengers[0].name} { test.numPassengers>1 ? " and "+(test.numPassengers-1)+ " other passengers" : ""}</td>
                      {tableRows(test)}
                      
                      <td>
                          <Button
                            onClick={() => openRequest(test)}
                            variant="primary"
                          >
                            Open
                          </Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>

            <Card.Text></Card.Text>
          </Form>
          <Card.Text></Card.Text>
        </Card.Body>
      </Card>
    </article>
  );
};

export default PhysicianMyRequests;
